import Typography from 'antd/es/typography';
import { styled } from 'styled-components';

const { Text } = Typography;

export const LayoutGrid = styled.div`
  ${({ theme }) => `
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: ${theme.marginXL}px;
  height: 100%;

  @media (max-width: ${theme.screenXL}px) {
    grid-template-columns: 350px 1fr;
  }

  @media (max-width: ${theme.screenLG}px) {
    grid-template-columns: 1fr;
    grid-template-rows: 400px 1fr;
  }
`}
`;

export const ColumnListPanel = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  border: ${`${theme.lineWidth}px solid ${theme.colorBorder}`};
  border-radius: ${theme.borderRadius}px;
  background: ${theme.colorBgContainer};
  overflow: hidden;
`}
`;

export const ColumnListHeader = styled.div`
  ${({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.padding}px ${theme.paddingXL}px;
  border-bottom: ${`${theme.lineWidth}px solid ${theme.colorBorder}`};
  background: ${theme.colorFillQuaternary};
`}
`;

export const ColumnListContent = styled.div`
  ${({ theme }) => `
  flex: 1;
  overflow-y: auto;
  padding: ${theme.padding}px;
`}
`;

export const ColumnItem = styled.div<{
  $selected?: boolean;
  $isDragging?: boolean;
}>`
  ${({ theme, $selected, $isDragging }) => `
  display: flex;
  align-items: center;
  padding: ${theme.paddingSM}px
    ${theme.paddingMD}px;
  margin-bottom: ${theme.marginXS}px;
  border-radius: ${theme.borderRadius}px;
  cursor: pointer;
  background: ${$selected ? theme.colorPrimaryBg : theme.colorBgContainer};
  border: ${`${theme.lineWidth}px solid ${theme.colorBorder}`};
  opacity: ${$isDragging ? theme.opacityImage * 0.5 : 1};
  transition: all ${theme.motionDurationMid};

  &:hover {
    background: ${$selected ? theme.colorPrimaryBg : theme.colorFillSecondary};
  }
`}
`;

export const DragHandle = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  margin-right: ${theme.marginSM}px;
  color: ${theme.colorTextTertiary};
  cursor: move;
`}
`;

export const ColumnInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ColumnName = styled(Text)`
  display: block;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColumnSource = styled(Text)`
  ${({ theme }) => `
  display: block;
  font-size: ${theme.fontSizeSM}px;
  color: ${theme.colorTextSecondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`}
`;

export const EditorPanel = styled.div`
  ${({ theme }) => `
  border: ${`${theme.lineWidth}px solid ${theme.colorBorder}`};
  border-radius: ${theme.borderRadius}px;
  background: ${theme.colorBgContainer};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`}
`;

export const JsonEditorContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  height: ${theme.controlHeightLG * 15}px;
  border: ${theme.lineWidth}px solid ${theme.colorBorder};
  border-radius: ${theme.borderRadius}px;
  overflow: hidden;
`}
`;

export const JsonEditorHeader = styled.div`
  ${({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.paddingSM}px ${theme.padding}px;
  border-bottom: ${theme.lineWidth}px solid ${theme.colorBorder};
  background: ${theme.colorFillQuaternary};
  flex-shrink: 0;
`}
`;

export const PageContainer = styled.div`
  ${({ theme }) => `
  padding: ${theme.paddingXL}px;
  max-width: ${theme.controlHeightLG * 30}px;
  margin: 0 auto;
`}
`;

export const Header = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.margin}px;
  margin-bottom: ${theme.marginXL}px;
  flex-wrap: wrap;
`}
`;

export const ContentArea = styled.div`
  ${({ theme }) => `
  background: ${theme.colorBgContainer};
  border-radius: ${theme.borderRadius}px;
  padding: ${theme.paddingXL}px;
`}
`;

export const EmptyState = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${theme.colorTextTertiary};
`}
`;
